import { useContext } from 'react';
import { DeviceSettingContext } from '../context/device-setting-context';

const useDeviceSettingContext = () => {
  const context = useContext(DeviceSettingContext);
  if (!context) {
    throw new Error('useDeviceSettingContext must be used within a DeviceSettingContext');
  }
  return context;
};
export default useDeviceSettingContext;
